import React from "react";
import { TranslateIcon } from "@phosphor-icons/react"

import { useGetQueryData } from "../../../../../../../utils/react-query-hooks/general";

import {
  DropdownSingle,
  getBreakPoint,
  useScreenWidth
} from "oolib";
import { trackEventGA } from "../../../../../../../trackers/GA/trackEventGA";
import { useAppSettingsContext } from "../../../../../../../contexts/appSettingsContext";
import { ButtonGhost } from "oolib/dist/v2/components/Buttons";

export const DividerVertical = ({ }) => <div style={{ height: "2.4rem", borderRight: "1px solid #D4D4D4" }} />

export const HeaderLanguageSelect = ({
  showOnlyOnLG = true,
  paddingLeft
}) => {
  const screenWidth = useScreenWidth();

  const { APP_SETTINGS, APP_SETTINGS_DISPATCH } = useAppSettingsContext();

  const {
    deployment: { _AppLanguageOptions },
  } = useGetQueryData("platformConfigs");

  const LangDropdown = (
    <DropdownSingle
      value={APP_SETTINGS.lang}
      options={_AppLanguageOptions}
      selectStyleOverride={{ border: "none"}}
      genCustomSelectComp={() => {
        return (<ButtonGhost
            icon={"Translate"}
            typo="UI_BODY_SEMIBOLD_SM_DF"
            iconSize={"S"} 
            style={{ paddingLeft: "1.2rem", paddingRight: "1.4rem", borderRadius: "3.7rem" }}
            children={APP_SETTINGS?.lang?.display}
        />)
      }} 
      onChange={(k, v) => {
        trackEventGA(
          "Translation Flow",
          "PrimaryHeader Translate",
          `${v?.value}`
        );
        APP_SETTINGS_DISPATCH({
          type: "SET_LANG",
          payload: v,
        });
      }}
      selectClassName={"SANS_2"}
    />
  );
const screenWidthCheck = showOnlyOnLG 
?  screenWidth >= getBreakPoint("lg")
: true
  return (
    <>
      {_AppLanguageOptions &&
        _AppLanguageOptions.length > 1 &&
        screenWidthCheck && (
          <>
          <div
            style={{
              paddingLeft,
              display: "flex",
              gap: "1rem",
              alignItems: "center",
            }}
            id="header_language_select" /** Id is v. important for coachmark to work */
          >
            {/* <TranslateIcon size={16} /> */}
            {LangDropdown}
            
          </div>
          <DividerVertical/>
          </>
        )}
    </>
  );
};
